import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { MyFocusLoyaltyMemberDTO } from "../../models/DTO/MyFocus-Loyalty.dto";
import { OOCheck } from "../../models/oo-check";

@Component({
	selector: "app-loyalty-account-lookup-post",
	templateUrl: "./loyalty-account-lookup-post.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class LoyaltyAccountLookupPostComponent implements OnInit {
	@Input() check: OOCheck;
	@Input() venueKey: number;
	@Input() postImmediately: boolean;

	memberData: MyFocusLoyaltyMemberDTO;

	phoneNumber: string;
	postComplete: boolean = false;

	saving: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {}

	async processLoyalty(phoneNumber) {
		this.saving = true;
		const memberData = await this.loyaltyLookup(this.venueKey, this.phoneNumber);
		if (memberData) {
			await this.loyaltySaveToCheck(memberData.AcctNo);
		}
		this.saving = false;
	}

	async loyaltyLookup(venueKey: number, phone: string): Promise<MyFocusLoyaltyMemberDTO> {
		try {
			const memberData: any = await this.focuslink.loyaltyMemberInquiry(venueKey, phone);
			this.memberData = new MyFocusLoyaltyMemberDTO(memberData);
			return this.memberData;
		} catch (error) {
			this.app.msgSvc.add({
				severity: "error",
				detail: "Sorry, we couldn't find your loyalty account.",
				key: "sidebar",
			});
			return undefined;
		}
	}

	async loyaltySaveToCheck(loyaltyAccount: string) {
		try {
			await this.focuslink.loyaltySave(this.venueKey, this.check.checkKey, loyaltyAccount);
			if (this.check.futureOrder === "now" || this.postImmediately) {
				await this.focuslink.loyaltyProcess(this.venueKey, this.check.checkKey);
			}
			this.app.msgSvc.add({
				severity: "success",
				detail: "Thanks for your loyalty! Your points have been posted.",
			});
			this.postComplete = true;
		} catch (error) {
			console.log(error);
			this.app.msgSvc.add({
				severity: "error",
				detail: "Sorry, there was an error posting your loyalty points.",
				key: "sidebar",
			});
		}
	}
}
